import { useQueryWithUserId } from '@northladder/services';

import { BIDS_API } from '../bidsAPIClient';

/**
 * React Query state key for fetch BIDDING WINDOW INFO api.
 */
const FETCH_BIDDING_INFO_QUERY_KEY = 'fetch-bidding-info-query-key';

interface IUseBiddingWindowInfoQueryProps {
  isEnabled?: boolean;
}

/**
 * React Query hook for bidding window info api management.
 * Calls `fetchBiddingWindowInfo` and provides error/loading/success state.
 */
export const useBiddingWindowInfoQuery = (
  options?: IUseBiddingWindowInfoQueryProps
) => {
  const { isEnabled = true } = options || {};
  const { data, isError, error, isPending, refetch, isFetching } =
    useQueryWithUserId({
      enabled: isEnabled,
      queryKey: [FETCH_BIDDING_INFO_QUERY_KEY],
      queryFn: () => BIDS_API.fetchBiddingWindowInfo(),
      retry: false,
    });

  return {
    error,
    isError,
    data,
    isPending,
    isFetching,
    refetch,
  };
};
